/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Link, Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Navbar from "./Navbar";
import axios from "axios";
import CheckoutSteps from "./CheckOutProgress";
const SERVER_URL = process.env.REACT_APP_SERVER_URL

const PaymentPage = () => {
  const [savedAddresses, setSavedAddresses] = useState(null);
  const [currentShippingAddress, setCurrentShippingAddress] = useState("")
  const dispatch = useDispatch();
  const { cartProducts, totalQuantities, totalPrice, myOrders, totalAmount } =
    useSelector((state) => state.cartReducer);

  const [paymentMode, setpaymentMode] = useState(null);

  useEffect(() => {
    console.log(JSON.parse(localStorage.getItem("shippingAddresses")));
    console.log(JSON.parse(localStorage.getItem("currentShippingAddress")));
    setCurrentShippingAddress(JSON.parse(localStorage.getItem("currentShippingAddress")))
    setSavedAddresses(JSON.parse(localStorage.getItem("shippingAddresses")));
  }, []);

  const placeOrder = () => {
    var unique = new Date().valueOf();
    var orderNumber = String(unique).substring(3, 13);

    var date = new Date();
    var day = date.toDateString();
    var time = date.toLocaleTimeString();
    var orderDate = day + " " + time;
    const orderTotal = totalAmount;

    const recent_order = {
      order_number: orderNumber,
      order_date: orderDate,
      order_total: orderTotal,
      cart_products: cartProducts,
      shipping_address: JSON.parse(
        localStorage.getItem("currentShippingAddress")
      ),
      payment_method: paymentMode,
    };
    console.log(recent_order);
    localStorage.setItem("recentOrder", JSON.stringify(recent_order));
    axios
      .post(
        SERVER_URL +
        "/api/orders/placeorder",
        {
          orderDetails: recent_order,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer " +
              JSON.parse(localStorage.getItem("userTokenTime")).token,
          },
        }
      )
      .then((res) => {
        console.log("order placed successfully!");
        localStorage.removeItem("currrentShippingAddress");
      })
      .catch((err) => {
        console.log(err);
      });
    dispatch({
      type: "EMPTY_CART",
      payload: recent_order,
    });
    console.log(myOrders);
  };

  if (!localStorage.getItem("userTokenTime")) return <Navigate to="/signin" />;
  else if (cartProducts.length === 0) return <Navigate to="/" />;
  else if (!localStorage.getItem("currentShippingAddress"))
    return <Navigate to="/shipping" />;

  return (
    <>
      <Navbar />
      <div className="container-z payment-page" style={{ paddingTop: "100px", backgroundColor: "white" }}>

        <CheckoutSteps step1 step2 step3></CheckoutSteps>
        <div className="row-y">
          <div className="column1 paymentLeft">
            <h5 className="">Payment</h5>
            <p>Select a Payment Method:</p>
            {/* <div className="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio1"
                name="customRadio"
                className="form-check-input"

              />
              <label className="custom-control-label" for="customRadio1">
                PayPal
              </label>
            </div>
            <div className="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio2"
                name="customRadio"
                className="custom-control-input"
                value="Stripe"
                onClick={(e) => {
                  setpaymentMode(e.target.value);
                  console.log(e.target.value);
                }}
              />
              <label className="custom-control-label" for="customRadio2">
                Stripe
              </label>
            </div>
            <div className="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio3"
                name="customRadio"
                className="custom-control-input"
                value="Netbanking"
                onClick={(e) => {
                  setpaymentMode(e.target.value);
                  console.log(e.target.value);
                }}
              />
              <label className="custom-control-label" for="customRadio3">
                Netbanking
              </label>
            </div>
            <div className="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio4"
                name="customRadio"
                className="custom-control-input"
                value="Debit Card"
                onClick={(e) => {
                  setpaymentMode(e.target.value);
                  console.log(e.target.value);
                }}
              />
              <label className="custom-control-label" for="customRadio4">
                Debit Card
              </label>
            </div>
            <div className="custom-control custom-radio">
              <input
                type="radio"
                id="customRadio5"
                name="customRadio"
                className="custom-control-input"
                value="Credit Card"
                onClick={(e) => {
                  setpaymentMode(e.target.value);
                  console.log(e.target.value);
                }}
              />
              <label className="custom-control-label" for="customRadio5">
                Credit Card
              </label>
            </div> */}

            <div class="form-check custom-control">
              <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1"
                value="PayPal"
                onClick={(e) => {
                  setpaymentMode(e.target.value);
                  console.log(e.target.value);
                }}
              />
              <label class="form-check-label" for="flexRadioDefault1">
                Paypal
              </label>
            </div>
            <div class="form-check custom-control">
              <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1"
                value="Stripe"
                onClick={(e) => {
                  setpaymentMode(e.target.value);
                  console.log(e.target.value);
                }}
              />
              <label class="form-check-label" for="flexRadioDefault1">
                Stripe
              </label>
            </div>
            <div class="form-check custom-control">
              <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1"
                value="Netbanking"
                onClick={(e) => {
                  setpaymentMode(e.target.value);
                  console.log(e.target.value);
                }}
              />
              <label class="form-check-label" for="flexRadioDefault1">
                Netbanking
              </label>
            </div>
            <div class="form-check custom-control">
              <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1"
                value="Debit Card"
                onClick={(e) => {
                  setpaymentMode(e.target.value);
                  console.log(e.target.value);
                }}
              />
              <label class="form-check-label" for="flexRadioDefault1">
                Debit Card
              </label>
            </div>
            <div class="form-check custom-control">
              <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1"
                value="Credit Card"
                onClick={(e) => {
                  setpaymentMode(e.target.value);
                  console.log(e.target.value);
                }}
              />
              <label class="form-check-label" for="flexRadioDefault1">
                Credit Card
              </label>
            </div>



            <div className="my-3">
              <h5>Billing Address</h5>
              <b>{currentShippingAddress && currentShippingAddress.fullName}</b>
              <p style={{ marginBottom: "0px" }}>{currentShippingAddress && currentShippingAddress.address}</p>
              <p style={{ marginBottom: "0px" }}>
                {currentShippingAddress && currentShippingAddress.city}, {currentShippingAddress && currentShippingAddress.state} {currentShippingAddress && currentShippingAddress.postalCode}
              </p>
              <p>INDIA</p>
            </div>

            {/* <Link to="/">
              <button className="mt-3 btn btn-primary" onClick={placeOrder}>
                Place Order
              </button>
            </Link> */}
            <p className="mt-3">
              By placing your order, you are agreeing to our terms and
              conditions and privacy and cookie policy
            </p>
          </div>
          <div className="column2 shippingRight">
            <span className="price-heading">PRICE DETAILS ({cartProducts.length} Items)</span>
            <div className="desc-div">
              <div className="price-div">
                <div className="inner-row">
                  <div>Total MRP </div>
                  <span>₹ {totalPrice}</span>
                </div>
              </div>
              <div className="discount-div">
                <div className="inner-row">
                  <div>Discount on MRP</div>
                  <span>-₹{totalPrice - totalAmount}</span>
                </div>
              </div>
              <div className="delivery-div">
                <div className="inner-row">
                  <div>Delivery Charges</div>
                  <span><s style={{ marginRight: "5px", color: "black" }}>₹99</s>FREE</span>
                </div>
              </div>
              <div className="totalprice-div">
                <div className="inner-row">
                  <div>Total Amount</div>
                  <span>₹ {totalAmount}</span>
                </div>
              </div>
              <div className="place-order-btn">
                <Link to="/">
                  <div
                    className="btn"
                    onClick={placeOrder}
                  >
                    Pay and Order
                  </div>
                </Link>
              </div>
              <div className="savings">You will save ₹{totalPrice - totalAmount + 99} on this order</div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default PaymentPage;
